import api from './api'
import type { 
  Role, 
  RoleCreate, 
  RoleUpdate, 
  Permission, 
  RolePermissionUpdate,
  RolePermissionGrantInput,
} from '@/types/rbac.types'

const BASE_URL = '/api/v1/auth/rbac'

export const rbacService = {
  // Roles
  async getRoles(skip = 0, limit = 100): Promise<Role[]> {
    const response = await api.get<Role[]>(`${BASE_URL}/roles`, { params: { skip, limit } })
    return response.data
  },

  async createRole(data: RoleCreate): Promise<Role> {
    const response = await api.post<Role>(`${BASE_URL}/roles`, data)
    return response.data
  },

  async updateRole(id: number, data: RoleUpdate): Promise<Role> {
    const response = await api.put<Role>(`${BASE_URL}/roles/${id}`, data)
    return response.data
  },

  async deleteRole(id: number): Promise<void> {
    await api.delete(`${BASE_URL}/roles/${id}`)
  },

  async updateRolePermissions(roleId: number, grants: RolePermissionGrantInput[]): Promise<Role> {
    const payload: RolePermissionUpdate = { grants }
    const response = await api.put<Role>(`${BASE_URL}/roles/${roleId}/permissions`, payload)
    return response.data
  },

  // Permissions
  async getPermissions(skip = 0, limit = 100): Promise<Permission[]> {
    const response = await api.get<Permission[]>(`${BASE_URL}/permissions`, { params: { skip, limit } })
    return response.data
  },

  async getMyPermissions(): Promise<string[]> {
    const response = await api.get<string[]>(`${BASE_URL}/users/me/permissions`)
    return response.data
  },
}

